var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlueHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 77,
    viewBox: "0 0 133 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_13184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05519 1.99023H71.6583C73.9318 1.99023 75.7543 3.79849 75.8078 6.06962V71.4486C75.8078 73.7114 73.9924 75.5222 71.715 75.5222H6.05519C3.7778 75.5222 1.9624 73.7114 1.9624 71.4486V6.06379C1.9624 3.80104 3.7778 1.99023 6.05519 1.99023ZM19.9572 38.4174C19.9572 48.8015 28.4037 57.2681 38.8851 57.2681C49.3097 57.2681 57.8129 48.8015 57.8129 38.361C57.8129 27.9164 49.3057 19.5668 38.8851 19.5668C28.4614 19.5668 19.9572 28.0323 19.9572 38.4174Z",
    fill: "#407DBB",
    stroke: "#237FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.112 38.3604C132.112 48.2171 124.087 56.2111 114.184 56.2111C104.281 56.2111 96.2563 48.2171 96.2563 38.3604C96.2563 28.5038 104.281 20.5098 114.184 20.5098C124.087 20.5098 132.112 28.5038 132.112 38.3604Z",
    fill: "#407DBB",
    stroke: "#237FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_13184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 76,
    fill: "white",
    transform: "translate(0.611816 0.642578)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlueHeader);
export default __webpack_public_path__ + "static/media/logo-blue-header.35fd02b9f8f1c56e91d730f24e7a0c7d.svg";
export { ForwardRef as ReactComponent };